import React, { createContext, useContext, useState, useEffect } from 'react';
import socketService from '../services/socketService';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const [isConnected, setIsConnected] = useState(false);
    const [socketModal, setSocketModal] = useState({
        open: false,
        message: '',
        type: 'success'
    });

    useEffect(() => {
        if (isAuthenticated) {
            const token = localStorage.getItem('authToken');
            if (token) {
                // Connect socket
                const socket = socketService.connect(token);
                
                if (socket) {
                    setIsConnected(true);

                    // Listen for join-success
                    socketService.on('join-success', (data) => {
                        setSocketModal({
                            open: true,
                            message: data.message || 'Successfully connected to server!',
                            type: 'success'
                        });
                    });

                    // Listen for join-error
                    socketService.on('join-error', (data) => {
                        setSocketModal({
                            open: true,
                            message: data.message || 'Connection failed!',
                            type: 'error'
                        });
                    });

                    // Listen for disconnect
                    socketService.on('disconnect', () => {
                        setIsConnected(false);
                    });

                    // Listen for reconnect
                    socketService.on('reconnect', () => {
                        setIsConnected(true);
                    });
                }
            }
        } else {
            // Disconnect socket when user logs out
            socketService.disconnect();
            setIsConnected(false);
        }

        // Cleanup on unmount
        return () => {
            socketService.disconnect();
        };
    }, [isAuthenticated]);

    const closeSocketModal = () => {
        setSocketModal(prev => ({ ...prev, open: false }));
    };

    const emitEvent = (event, data) => {
        socketService.emit(event, data);
    };

    const onEvent = (event, callback) => {
        socketService.on(event, callback);
    };

    const offEvent = (event, callback) => {
        socketService.off(event, callback);
    };

    return (
        <SocketContext.Provider value={{
            isConnected,
            socket: socketService.getSocket(),
            emitEvent,
            onEvent,
            offEvent,
            socketModal,
            closeSocketModal
        }}>
            {children}
        </SocketContext.Provider>
    );
};
